'use client';

import { Box, Container, styled, Typography } from '@mui/material';
import MoButtonLink from ':src/components/MoButtonLink';

const HeroBanner = styled('div')(({ theme }) => ({
  margin: '-32px auto 0',
  backgroundImage: `url(${process.env.NEXT_PUBLIC_IMGIX_HOSTNAME}/static/about-banner.png?auto=format)`,
  backgroundPosition: 'right -450px top',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  maxWidth: 1600,

  '@media (min-width: 500px)': {
    backgroundPosition: 'right -300px top',
  },

  '@media (min-width: 700px)': {
    backgroundPosition: 'right -200px top',
  },

  [theme.breakpoints.up('sm')]: {
    marginTop: -64,
  },

  [theme.breakpoints.up('md')]: {
    backgroundSize: 'contain',
    backgroundPosition: 'right -150px center',
  },

  [theme.breakpoints.up('lg')]: {
    backgroundPosition: 'right center',
  },
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    maxWidth: 1400,
  },
}));

const HeroHeaderWrapper = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  width: '220px',

  '@media (min-width: 700px)': {
    width: '350px',
  },

  '@media (min-width: 1000px)': {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
  },
}));

const HeroHeader = styled(Typography)({
  fontSize: 24,

  '@media (min-width: 700px)': {
    fontSize: 30,
  },
});

export default function AboutBanner() {
  return (
    <HeroBanner>
      <StyledContainer>
        <HeroHeaderWrapper>
          <HeroHeader variant="h1">
            Growing together through quality continuing education
          </HeroHeader>
          <Box mt={2}>
            <MoButtonLink href="/signup">Join Motivo Learning</MoButtonLink>
          </Box>
        </HeroHeaderWrapper>
      </StyledContainer>
    </HeroBanner>
  );
}
